import {ApplicationLayout} from "@rio-cloud/rio-uikit"
import styled from "@emotion/styled";
import {useAuthenticationStore} from "../../store/auth.ts";


export const LoginPage = () => {



    const { setAuthenticated} = useAuthenticationStore();

    const Floater = styled.div`
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    `

    const Paper = styled.div`
        flex: 1;
        background: white;
        padding: 20px;
        max-width: 400px;
        border-radius: 5px;
    `


    const submitEventHandler = (e: any) => {
        e.preventDefault()

        //@ts-ignore
        const password = event.target[1].value
        //@ts-ignore
        const username = event.target[0].value


        const formData = new FormData();
        formData.append("RedirectTo", "/cartright/cartrightTMS.nsf/UserCC_Profile.xsp?Open")
        formData.append("$PublicAccess", "1")
        formData.append("$$HTMLTagAttributes", "lang=\\")
        formData.append("ReasonType", "0")
        formData.append("Username", username)
        formData.append("Password", password)

        fetch("/names.nsf?Login=", {
            method: "POST",
            body: formData,
        }).then(res => {
            console.log("response",res)
            fetch("/cartright/cartrightTMS.nsf/api.xsp/api/integration/checkauth")
                .then(async res => {
                    const text = await res.text()
                    if (text.startsWith("{")) {
                        const json = JSON.parse(text)
                        if (json.authenticated === true) {
                            setAuthenticated(true);
                        }
                    }

                })
                .catch(e => {
                    console.error(e)
                })

        })
            .catch((error) => {
                console.log("error", error)
                fetch("/cartright/cartrightTMS.nsf/api.xsp/api/integration/checkauth")
                    .then(async res => {
                        const text = await res.text()
                        if (text.startsWith("{")) {
                            const json = JSON.parse(text)
                            if (json.authenticated === true) {
                                setAuthenticated(true);
                            }
                        }

                    })
                    .catch(e => {
                        console.error(e)
                    })

            })
    }

    return <ApplicationLayout>
        <ApplicationLayout.Body innerClassName={(window.self !== window.top) ? "padding-0" : ""}>
            <Floater>
                <Paper>
                    <div className={"margin-top-20-sm text-center"}>
                        <h2>Login</h2>
                    </div>
                    <form onSubmit={submitEventHandler}>
                        <div className="form-group">
                            <label htmlFor="email">User Name</label>
                            <input className={"form-control"} type="text" id="email" name="email"/>
                        </div>
                        <div className={"form-group"}>
                            <label htmlFor={"password"}>Password</label>
                            <input className={"form-control"} type={"password"} id={"password"} name={"password"}/>
                        </div>
                        <div className={"margin-top-20-sm text-right"}>
                            <input type="submit" className={"btn btn-primary"} value="Login"/>
                        </div>
                    </form>
                </Paper>
            </Floater>
        </ApplicationLayout.Body>
    </ApplicationLayout>


}